import {I18n} from '@aws-amplify/core';

import {FlexiAddButton,} from '@flexinet/ui-components';

import {
    useNavigate,
    useParams
} from 'react-router-dom';
import {moduleConfig} from "../config";

export const AddRecordButton = ({
                                    buttonText = `Add ${moduleConfig.titles.singular}`,
                                    size = 'sm',
                                    onClick,
                                }: {
    buttonText?: string,
    size?: string,
    onClick?: () => void
}) => {
    const {id: productId} = useParams()

    const navigate = useNavigate();

    if (typeof onClick === 'undefined') {
        onClick = () => {
            navigate(`/products/${productId}/product-line-items/add`);
        };
    }

    return (
        <FlexiAddButton
            onClick={onClick}
            size={size}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};
